<div class="dashboard-header-wrapper">
    <h1>
        <b>{{'common.dashboard' | localize}}</b>
    </h1>
</div>